<template>
    <v-dialog v-model="getModalMovimentacaoEstoque" persistent max-width="500px" transition="dialog-transition">
        <v-card>
            <v-card-title>
                Movimentação de Estoque
            </v-card-title>
            <v-form ref="form" class="px-3">
                <v-card-text>
                    <v-flex xs12 md12>
                        <v-select :items="tipos" v-model="movimentacao.tipo" label="Tipo" outlined dense
                            :rules="rules.tipo">
                        </v-select>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-text-field label="Quantidade" v-model="movimentacao.quantidade" outlined dense
                            v-mask="['#,###', '##,###', '###,###']" :rules="rules.quantidade">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-select :items="getEstoques" item-text="nome" item-value="id"
                            v-model="movimentacao.estoque_origem_id" label="Estoque" outlined dense
                            :rules="rules.estoque_origem_id">
                            <template slot="selection" slot-scope="data"> {{data.item.nome}}  <span v-if="data.item.principal" class="ml-2"> (Principal)</span></template>
                            <template slot="item" slot-scope="data"> {{data.item.nome}} <span v-if="data.item.principal" class="ml-2">(Principal)</span></template>
                        </v-select>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="default" @click="setModalMovimentacaoEstoque(false)" outlined :loading="$store.getters.getOverlay">Voltar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="salvar" outlined :loading="$store.getters.getOverlay">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import EstoqueService from '@/services/EstoqueService'
    export default {
        data() {
            return {
                movimentacao: {
                    produto_id: '',
                    descricao: '',
                    quantidade: '',
                    estoque_origem_id: '',
                    tipo: ''
                },
                tipos: [
                    'ENTRADA',
                    'SAIDA'
                ],
                rules: {
                    // produto_id: [
                    //     v => !!v || 'Campo obrigatório.'
                    // ],
                    // descricao: [
                    //     v => !!v || 'Campo obrigatório.'
                    // ],
                    quantidade: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    estoque_origem_id: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    tipo: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                }
            }
        },
        computed: {
            ...mapGetters([
                'getModalMovimentacaoEstoque',
                'getProduto',
                'getEstoques',
                'getOrcamento',
                'getItensOrcamento'

            ])
        },
        methods: {
            ...mapActions([
                'listarEstoque',
                'setModalMovimentacaoEstoque'
            ]),
            salvar() {
                this.movimentacao.produto_id = this.getProduto.id
                this.movimentacao.descricao = this.getProduto.descricao
                this.$store.commit('setOverlay', true)
                EstoqueService.movimentacao(this.movimentacao)
                    .then(res => {
                        this.setModalMovimentacaoEstoque(false)
                        this.$store.dispatch('visualizarProduto', this.movimentacao.produto_id)
                        this.$store.dispatch('listarProdutos', { limite: 20, pagina: 1 })
                        this.$store.commit('setOverlay', false)
                        this.$store.commit('snackbarSuccess', 'Movimentação de estoque efetuada com sucesso.')
                        
                        const estoque = res.data.filter(item => item.estoque.principal)

                        if(this.getOrcamento.id){
                            const indice = this.getItensOrcamento.map(item => item.produto_id).indexOf(this.movimentacao.produto_id)
                            this.getItensOrcamento[indice].estoque = estoque[0].quantidade
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
        },
        created() {
            this.listarEstoque()
        }
    }
</script>